import _definePage_default_0 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/add-pupil.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/add-teacher.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/alloc-pupils.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/alloc-teachers.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/preferences.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/pupil/[pupilId].vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting-combined-results.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting-overview.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting-usage.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/view-classes.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/view-pupils.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/view-teachers.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/landing.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/logout.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/avatar.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/home.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/read-book/[[pupil_task_id]].vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/read-book/epub/[[pupil_task_id]].vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book/[book_id]/view-epub.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/login.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/add-pupil.vue?definePage&vue&lang.tsx'
import _definePage_default_23 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/book/[book_id]/about.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/book/[book_id]/view-epub.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/books.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/groups.vue?definePage&vue&lang.tsx'
import _definePage_default_27 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/home.vue?definePage&vue&lang.tsx'
import _definePage_default_28 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/manage-sharing.vue?definePage&vue&lang.tsx'
import _definePage_default_29 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/mark/[[pupil_task_id]].vue?definePage&vue&lang.tsx'
import _definePage_default_30 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/marking.vue?definePage&vue&lang.tsx'
import _definePage_default_31 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/marking-overview.vue?definePage&vue&lang.tsx'
import _definePage_default_32 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/message/[[message_id].vue?definePage&vue&lang.tsx'
import _definePage_default_33 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/messages.vue?definePage&vue&lang.tsx'
import _definePage_default_34 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/profile.vue?definePage&vue&lang.tsx'
import _definePage_default_35 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/pupil/[[pupilId]].vue?definePage&vue&lang.tsx'
import _definePage_default_36 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/pupils-and-groups.vue?definePage&vue&lang.tsx'
import _definePage_default_37 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting.vue?definePage&vue&lang.tsx'
import _definePage_default_38 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-combined-results.vue?definePage&vue&lang.tsx'
import _definePage_default_39 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-overview.vue?definePage&vue&lang.tsx'
import _definePage_default_40 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-question-set.vue?definePage&vue&lang.tsx'
import _definePage_default_41 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-usage.vue?definePage&vue&lang.tsx'
import _definePage_default_42 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/task/[[task_id]]/view-task.vue?definePage&vue&lang.tsx'
import _definePage_default_43 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/view-pupils.vue?definePage&vue&lang.tsx'
import _definePage_default_44 from '/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/ws/ws-signup.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'add-class',
        name: '/admin/add-class',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/add-class.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'add-pupil',
          name: '/admin/add-pupil',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/add-pupil.vue'),
          /* no children */
        },
        _definePage_default_0
      ),
      _mergeRouteRecord(
        {
          path: 'add-teacher',
          name: '/admin/add-teacher',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/add-teacher.vue'),
          /* no children */
        },
        _definePage_default_2
      ),
      _mergeRouteRecord(
        {
          path: 'alloc-pupils',
          name: '/admin/alloc-pupils',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/alloc-pupils.vue'),
          /* no children */
        },
        _definePage_default_3
      ),
      _mergeRouteRecord(
        {
          path: 'alloc-teachers',
          name: '/admin/alloc-teachers',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/alloc-teachers.vue'),
          /* no children */
        },
        _definePage_default_4
      ),
      {
        path: 'class',
        /* internal name: '/admin/class' */
        /* no component */
        children: [
          {
            path: ':classUid',
            name: '/admin/class/[classUid]',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/class/[classUid].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'home',
        name: '/admin/home',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/home.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'preferences',
          name: '/admin/preferences',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/preferences.vue'),
          /* no children */
        },
        _definePage_default_5
      ),
      {
        path: 'pupil',
        /* internal name: '/admin/pupil' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':pupilId',
              name: '/admin/pupil/[pupilId]',
              component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/pupil/[pupilId].vue'),
              /* no children */
            },
            _definePage_default_6
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'reporting',
          name: '/admin/reporting',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting.vue'),
          /* no children */
        },
        _definePage_default_7
      ),
      _mergeRouteRecord(
        {
          path: 'reporting-combined-results',
          name: '/admin/reporting-combined-results',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting-combined-results.vue'),
          /* no children */
        },
        _definePage_default_8
      ),
      _mergeRouteRecord(
        {
          path: 'reporting-overview',
          name: '/admin/reporting-overview',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting-overview.vue'),
          /* no children */
        },
        _definePage_default_9
      ),
      _mergeRouteRecord(
        {
          path: 'reporting-usage',
          name: '/admin/reporting-usage',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/reporting-usage.vue'),
          /* no children */
        },
        _definePage_default_10
      ),
      {
        path: 'teacher',
        /* internal name: '/admin/teacher' */
        /* no component */
        children: [
          {
            path: ':teacherId',
            name: '/admin/teacher/[teacherId]',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/teacher/[teacherId].vue'),
            /* no children */
          }
        ],
      },
      _mergeRouteRecord(
        {
          path: 'view-classes',
          name: '/admin/view-classes',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/view-classes.vue'),
          /* no children */
        },
        _definePage_default_11
      ),
      _mergeRouteRecord(
        {
          path: 'view-pupils',
          name: '/admin/view-pupils',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/view-pupils.vue'),
          /* no children */
        },
        _definePage_default_12
      ),
      _mergeRouteRecord(
        {
          path: 'view-teachers',
          name: '/admin/view-teachers',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/admin/view-teachers.vue'),
          /* no children */
        },
        _definePage_default_13
      )
    ],
  },
  _mergeRouteRecord(
    {
      path: '/landing',
      name: '/landing',
      component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/landing.vue'),
      /* no children */
    },
    _definePage_default_14
  ),
  _mergeRouteRecord(
    {
      path: '/logout',
      name: '/logout',
      component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/logout.vue'),
      /* no children */
    },
    _definePage_default_15
  ),
  {
    path: '/pupil',
    /* internal name: '/pupil' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'avatar',
          name: '/pupil/avatar',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/avatar.vue'),
          /* no children */
        },
        _definePage_default_16
      ),
      {
        path: 'change-book',
        name: '/pupil/change-book',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/change-book.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'home',
          name: '/pupil/home',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/home.vue'),
          /* no children */
        },
        _definePage_default_17
      ),
      {
        path: 'message',
        /* internal name: '/pupil/message' */
        /* no component */
        children: [
          {
            path: ':message_id?',
            name: '/pupil/message/[[message_id]',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/message/[[message_id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'messages',
        name: '/pupil/messages',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/messages.vue'),
        /* no children */
      },
      {
        path: 'profile',
        name: '/pupil/profile',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/profile.vue'),
        /* no children */
      },
      {
        path: 'read-book',
        /* internal name: '/pupil/read-book' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':pupil_task_id?',
              name: '/pupil/read-book/[[pupil_task_id]]',
              component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/read-book/[[pupil_task_id]].vue'),
              /* no children */
            },
            _definePage_default_18
          ),
          {
            path: 'epub',
            /* internal name: '/pupil/read-book/epub' */
            /* no component */
            children: [
              _mergeRouteRecord(
                {
                  path: ':pupil_task_id?',
                  name: '/pupil/read-book/epub/[[pupil_task_id]]',
                  component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/read-book/epub/[[pupil_task_id]].vue'),
                  /* no children */
                },
                _definePage_default_19
              )
            ],
          }
        ],
      },
      {
        path: 'tlc-upgrade',
        name: '/pupil/tlc-upgrade',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/pupil/tlc-upgrade.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/staff',
    /* internal name: '/staff' */
    /* no component */
    children: [
      {
        path: 'add-resource',
        name: '/staff/add-resource',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/add-resource.vue'),
        /* no children */
      },
      {
        path: 'book',
        /* internal name: '/staff/book' */
        /* no component */
        children: [
          {
            path: ':book_id',
            /* internal name: '/staff/book/[book_id]' */
            /* no component */
            children: [
              {
                path: 'copy-tasks',
                name: '/staff/book/[book_id]/copy-tasks',
                component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book/[book_id]/copy-tasks.vue'),
                /* no children */
              },
              {
                path: 'edit-book',
                name: '/staff/book/[book_id]/edit-book',
                component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book/[book_id]/edit-book.vue'),
                /* no children */
              },
              {
                path: 'section',
                /* internal name: '/staff/book/[book_id]/section' */
                /* no component */
                children: [
                  {
                    path: ':section_id',
                    name: '/staff/book/[book_id]/section/[section_id]',
                    component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book/[book_id]/section/[section_id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'view',
                name: '/staff/book/[book_id]/view',
                component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book/[book_id]/view.vue'),
                /* no children */
              },
              _mergeRouteRecord(
                {
                  path: 'view-epub',
                  name: '/staff/book/[book_id]/view-epub',
                  component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book/[book_id]/view-epub.vue'),
                  /* no children */
                },
                _definePage_default_20
              )
            ],
          },
          {
            path: 'add-book',
            name: '/staff/book/add-book',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book/add-book.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'book-count',
        name: '/staff/book-count',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/book-count.vue'),
        /* no children */
      },
      {
        path: 'books',
        name: '/staff/books',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/books.vue'),
        /* no children */
      },
      {
        path: 'export',
        name: '/staff/export',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/export.vue'),
        /* no children */
      },
      {
        path: 'featured-books',
        name: '/staff/featured-books',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/featured-books.vue'),
        /* no children */
      },
      {
        path: 'home',
        name: '/staff/home',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/home.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'login',
          name: '/staff/login',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/login.vue'),
          /* no children */
        },
        _definePage_default_21
      ),
      {
        path: 'notices',
        name: '/staff/notices',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/notices.vue'),
        /* no children */
      },
      {
        path: 'school',
        /* internal name: '/staff/school' */
        /* no component */
        children: [
          {
            path: ':school_id?',
            name: '/staff/school/[[school_id]]',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/school/[[school_id]].vue'),
            /* no children */
          },
          {
            path: 'add-school',
            name: '/staff/school/add-school',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/school/add-school.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'schools',
        name: '/staff/schools',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/schools.vue'),
        /* no children */
      },
      {
        path: 'task',
        /* internal name: '/staff/task' */
        /* no component */
        children: [
          {
            path: ':task_id?',
            name: '/staff/task/[[task_id]]',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/task/[[task_id]].vue'),
            /* no children */
          },
          {
            path: 'copy-resource',
            name: '/staff/task/copy-resource',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/task/copy-resource.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'tasks',
        name: '/staff/tasks',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/tasks.vue'),
        /* no children */
      },
      {
        path: 'teacher-tasks',
        name: '/staff/teacher-tasks',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/staff/teacher-tasks.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/teacher',
    /* internal name: '/teacher' */
    /* no component */
    children: [
      {
        path: 'about-kidsout',
        name: '/teacher/about-kidsout',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/about-kidsout.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'add-pupil',
          name: '/teacher/add-pupil',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/add-pupil.vue'),
          /* no children */
        },
        _definePage_default_22
      ),
      {
        path: 'book',
        /* internal name: '/teacher/book' */
        /* no component */
        children: [
          {
            path: ':book_id',
            /* internal name: '/teacher/book/[book_id]' */
            /* no component */
            children: [
              _mergeRouteRecord(
                {
                  path: 'about',
                  name: '/teacher/book/[book_id]/about',
                  component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/book/[book_id]/about.vue'),
                  /* no children */
                },
                _definePage_default_23
              ),
              {
                path: 'view',
                name: '/teacher/book/[book_id]/view',
                component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/book/[book_id]/view.vue'),
                /* no children */
              },
              _mergeRouteRecord(
                {
                  path: 'view-epub',
                  name: '/teacher/book/[book_id]/view-epub',
                  component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/book/[book_id]/view-epub.vue'),
                  /* no children */
                },
                _definePage_default_24
              )
            ],
          }
        ],
      },
      _mergeRouteRecord(
        {
          path: 'books',
          name: '/teacher/books',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/books.vue'),
          /* no children */
        },
        _definePage_default_25
      ),
      {
        path: 'create-task',
        /* internal name: '/teacher/create-task' */
        /* no component */
        children: [
          {
            path: ':book_id?',
            name: '/teacher/create-task/[[book_id]]',
            component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/create-task/[[book_id]].vue'),
            /* no children */
          }
        ],
      },
      _mergeRouteRecord(
        {
          path: 'groups',
          name: '/teacher/groups',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/groups.vue'),
          /* no children */
        },
        _definePage_default_26
      ),
      _mergeRouteRecord(
        {
          path: 'home',
          name: '/teacher/home',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/home.vue'),
          /* no children */
        },
        _definePage_default_27
      ),
      _mergeRouteRecord(
        {
          path: 'manage-sharing',
          name: '/teacher/manage-sharing',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/manage-sharing.vue'),
          /* no children */
        },
        _definePage_default_28
      ),
      {
        path: 'mark',
        /* internal name: '/teacher/mark' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':pupil_task_id?',
              name: '/teacher/mark/[[pupil_task_id]]',
              component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/mark/[[pupil_task_id]].vue'),
              /* no children */
            },
            _definePage_default_29
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'marking',
          name: '/teacher/marking',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/marking.vue'),
          /* no children */
        },
        _definePage_default_30
      ),
      _mergeRouteRecord(
        {
          path: 'marking-overview',
          name: '/teacher/marking-overview',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/marking-overview.vue'),
          /* no children */
        },
        _definePage_default_31
      ),
      {
        path: 'message',
        /* internal name: '/teacher/message' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':message_id?',
              name: '/teacher/message/[[message_id]',
              component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/message/[[message_id].vue'),
              /* no children */
            },
            _definePage_default_32
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'messages',
          name: '/teacher/messages',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/messages.vue'),
          /* no children */
        },
        _definePage_default_33
      ),
      _mergeRouteRecord(
        {
          path: 'profile',
          name: '/teacher/profile',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/profile.vue'),
          /* no children */
        },
        _definePage_default_34
      ),
      {
        path: 'pupil',
        /* internal name: '/teacher/pupil' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':pupilId?',
              name: '/teacher/pupil/[[pupilId]]',
              component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/pupil/[[pupilId]].vue'),
              /* no children */
            },
            _definePage_default_35
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'pupils-and-groups',
          name: '/teacher/pupils-and-groups',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/pupils-and-groups.vue'),
          /* no children */
        },
        _definePage_default_36
      ),
      _mergeRouteRecord(
        {
          path: 'reporting',
          name: '/teacher/reporting',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting.vue'),
          /* no children */
        },
        _definePage_default_37
      ),
      _mergeRouteRecord(
        {
          path: 'reporting-combined-results',
          name: '/teacher/reporting-combined-results',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-combined-results.vue'),
          /* no children */
        },
        _definePage_default_38
      ),
      _mergeRouteRecord(
        {
          path: 'reporting-overview',
          name: '/teacher/reporting-overview',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-overview.vue'),
          /* no children */
        },
        _definePage_default_39
      ),
      _mergeRouteRecord(
        {
          path: 'reporting-question-set',
          name: '/teacher/reporting-question-set',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-question-set.vue'),
          /* no children */
        },
        _definePage_default_40
      ),
      _mergeRouteRecord(
        {
          path: 'reporting-usage',
          name: '/teacher/reporting-usage',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/reporting-usage.vue'),
          /* no children */
        },
        _definePage_default_41
      ),
      {
        path: 'task',
        /* internal name: '/teacher/task' */
        /* no component */
        children: [
          {
            path: ':task_id?',
            /* internal name: '/teacher/task/[[task_id]]' */
            /* no component */
            children: [
              {
                path: 'edit-task',
                name: '/teacher/task/[[task_id]]/edit-task',
                component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/task/[[task_id]]/edit-task.vue'),
                /* no children */
              },
              _mergeRouteRecord(
                {
                  path: 'view-task',
                  name: '/teacher/task/[[task_id]]/view-task',
                  component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/task/[[task_id]]/view-task.vue'),
                  /* no children */
                },
                _definePage_default_42
              )
            ],
          }
        ],
      },
      {
        path: 'tlc-upgrade',
        name: '/teacher/tlc-upgrade',
        component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/tlc-upgrade.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'view-pupils',
          name: '/teacher/view-pupils',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/teacher/view-pupils.vue'),
          /* no children */
        },
        _definePage_default_43
      )
    ],
  },
  {
    path: '/ws',
    /* internal name: '/ws' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'ws-signup',
          name: '/ws/ws-signup',
          component: () => import('/home/runner/work/ilt_frontends/ilt_frontends/apps/giglets/src/pages/ws/ws-signup.vue'),
          /* no children */
        },
        _definePage_default_44
      )
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

